import { HourlyRate } from "@tm/context-distribution"
import { getCategoryOfWorkDescriptionTextId } from "@tm/utils"
import { VehicleType, WorkCategory } from "@tm/models"
import { RepairTimeChanged } from "./models"

export function mapHourlyRatesToRepairTimesChanged(updatedRates: HourlyRate[], translateText: (key: number | string) => string): RepairTimeChanged[] {
    const repairTimeList: RepairTimeChanged[] = []

    updatedRates.map((hourlyRate) =>
        repairTimeList.push({
            description: hourlyRate.category ? translateText(getCategoryOfWorkDescriptionTextId(hourlyRate.category)) : translateText(1812),
            hourlyRate: hourlyRate.hourlyRate,
            mainWorkId: hourlyRate.category?.toString() || WorkCategory.NotCategorized.toString(),
            vehicleType: VehicleType.Undefined,
        })
    )
    return repairTimeList
}
